import { Component, inject } from '@angular/core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { map, switchMap } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { OnboardingStatus } from 'src/app/core/enum/OnboardingStatus';
import { AuthService } from 'src/app/core/services/auth';
import { DashboardService } from 'src/app/core/services/dashboard';
import { SharedService } from 'src/app/core/services/shared';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent {
  authService = inject(AuthService);
  dashboardService = inject(DashboardService);
  sharedService = inject(SharedService);

  appName = this.sharedService.GetAppName();
  faExclamationTriangle = faExclamationTriangle;

  pendingOnboarding$ = this.authService.onboardingStatus$.pipe(
    map((status) => status !== OnboardingStatus.Finalizado)
  );

  dashboard$ = this.authService.empresaSelecionada$.pipe(
    switchMap(() => this.dashboardService.getDashboard())
  );
}
